var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkArrow = function SvgLinkArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.389.87 23 .933h.002l.065 17.614-2.446-.01-.05-13.477L1.945 23.687.21 21.951 18.795 3.365l-13.397-.05L5.388.87Z"
  })));
};
export { SvgLinkArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUuMzg4NjcgMC44NjkxNDFMMjMuMDAxNSAwLjkzNDE0MkwyMy4wMDE1IDAuOTM0ODA0TDIzLjAwMjkgMC45MzQ4MDlMMjMuMDY3OSAxOC41NDc2TDIwLjYyMTYgMTguNTM4NkwyMC41NzE5IDUuMDYwNTFMMS45NDUxMSAyMy42ODczTDAuMjA4OTg1IDIxLjk1MTJMMTguNzk1MyAzLjM2NDgxTDUuMzk3NyAzLjMxNTM2TDUuMzg4NjcgMC44NjkxNDFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";